// fill in both in order to get proper intellisense
export type BaseDict = {
    TodayEvents: string
    TomorrowEvents: string
    AntepostEvents: string
}
export const BaseDict: BaseDict = {
    TodayEvents: "Today",
    TomorrowEvents: "Tomorrow",
    AntepostEvents: "Future"
}